import { ReactElement } from 'react'
import styled from 'styled-components'

const Separator = styled.div`
	margin-top: 1.25em;
	font-weight: ${(p) => p.theme.font.serif.weight.bold};
`

export const BreadcrumbSeparator = (): ReactElement => <Separator>/</Separator>
